exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cut[data-v-77447314]{\n    margin-left: 100px;\n}\n", ""]);

// exports
